import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "overview",
    title: "ภาพรวม",
    summary:
      "หน้าแรกของคอนโซล แสดงตัวเลขสำคัญของระบบในพริบตา: จำนวนผู้ใช้ การเข้าสู่ระบบ ความพยายามเข้าสู่ระบบที่ล้มเหลว สัดส่วนผู้ใช้ที่เปิด MFA กราฟการเข้าสู่ระบบ 14 วัน และเหตุการณ์ล่าสุด",
    access:
      'ทุกคนที่มีสิทธิ์อ่านข้อมูลผู้ใช้ (เช่น owner, admin, auditor) เปิดหน้านี้ได้ ส่วน "เหตุการณ์ล่าสุด" แสดงเฉพาะผู้ที่มีสิทธิ์อ่านบันทึกการใช้งาน หน้านี้ดูได้อย่างเดียว ไม่มีอะไรให้แก้ไข',
    shot: {
      file: "overview-page.png",
      caption: 'หน้า "ภาพรวม": การ์ดตัวเลข 5 ใบ กราฟการเข้าสู่ระบบ 14 วันล่าสุด และเหตุการณ์ล่าสุด',
    },
    sections: [
      {
        id: "open",
        heading: "เปิดหน้าภาพรวม",
        body: [
          'กดเมนู "ภาพรวม" ที่ด้านบนสุดของแถบเมนูด้านซ้าย หรือกดชื่อผลิตภัณฑ์ หน้านี้เป็นหน้าแรกที่เห็นหลังเข้าสู่ระบบ ตัวเลขทั้งหมดดึงจากเซิร์ฟเวอร์ทุกครั้งที่เปิดหน้า ถ้าต้องการตัวเลขล่าสุดให้โหลดหน้าเว็บใหม่ (F5)',
          'ระหว่างโหลดจะเห็นกล่องสีเทากะพริบแทนตัวเลข ถ้าโหลดไม่สำเร็จจะเห็นกล่อง "เกิดข้อผิดพลาด" พร้อมปุ่ม "ลองอีกครั้ง"',
        ],
      },
      {
        id: "tiles",
        heading: "การ์ดตัวเลข",
        fieldsTitle: "ความหมายของแต่ละการ์ด",
        fields: [
          {
            name: "ผู้ใช้ทั้งหมด",
            description:
              "จำนวนบัญชีทั้งหมดในระบบ ทุกประเภท (พนักงาน ลูกค้า พาร์ทเนอร์ ฯลฯ) และทุกสถานะ รวมบัญชีที่ถูกระงับและบัญชีที่ยังรอยืนยัน",
          },
          {
            name: "ใช้งาน (7 วัน)",
            description:
              "จำนวนผู้ใช้ (นับคนละครั้ง) ที่เข้าสู่ระบบสำเร็จอย่างน้อยหนึ่งครั้งในช่วง 7 วันที่ผ่านมา นับย้อนจากเวลาปัจจุบัน",
          },
          {
            name: "เข้าสู่ระบบวันนี้",
            description:
              "จำนวนครั้งที่เข้าสู่ระบบสำเร็จของวันนี้ (คนเดียวเข้าหลายครั้งนับหลายครั้ง) วันเริ่มนับตามเวลาสากล UTC คือตั้งแต่ 07:00 น. เวลาประเทศไทย",
          },
          {
            name: "เข้าสู่ระบบล้มเหลว (24 ชม.)",
            description:
              "จำนวนครั้งที่เข้าสู่ระบบไม่สำเร็จ (เช่น รหัสผ่านผิด) ในช่วง 24 ชั่วโมงที่ผ่านมา ตัวเลขที่สูงผิดปกติอาจหมายถึงมีคนพยายามเดารหัสผ่าน",
          },
          {
            name: "การใช้ MFA",
            description:
              "สัดส่วน (เปอร์เซ็นต์) ของผู้ใช้ทั้งหมดที่เปิดการยืนยันตัวตนสองขั้นตอนแล้ว ยิ่งสูงยิ่งปลอดภัย",
          },
        ],
        tips: [
          'ถ้าตัวเลข "เข้าสู่ระบบล้มเหลว (24 ชม.)" สูงผิดปกติ ให้เปิด "บันทึกการใช้งาน" แล้วกรองเหตุการณ์ user.sign_in_failed เพื่อดูว่าเกิดกับบัญชีใดและมาจาก IP ใด',
          'ถ้า "การใช้ MFA" ต่ำ ลองพิจารณาเปลี่ยนนโยบาย MFA ในหน้า "วิธีเข้าสู่ระบบ" หรือกำหนดกฎ 2FA ต่อประเภทผู้ใช้ในหน้า "ประเภทผู้ใช้"',
        ],
      },
      {
        id: "chart",
        heading: 'กราฟ "การเข้าสู่ระบบ 14 วันล่าสุด"',
        body: [
          "กราฟเส้นแสดงจำนวนการเข้าสู่ระบบสำเร็จต่อวันของ 14 วันล่าสุด (รวมวันนี้) แกนนอนคือวันที่ในรูปแบบ เดือน-วัน (แสดงวันเว้นวัน) แกนตั้งคือจำนวนครั้ง",
          'ชี้เมาส์ที่จุดบนเส้นเพื่อดูวันที่และจำนวนที่แน่นอนของวันนั้น วันแบ่งตามเวลา UTC เหมือนการ์ด "เข้าสู่ระบบวันนี้"',
        ],
        tips: [
          "ใช้กราฟดูแนวโน้ม เช่น การใช้งานลดลงช่วงวันหยุด หรือการใช้งานเพิ่มขึ้นหลังเปิดแอปใหม่ ถ้าเส้นตกเป็นศูนย์กะทันหันในวันทำงาน อาจมีปัญหาที่หน้าเข้าสู่ระบบ ควรแจ้งทีมไอที",
        ],
      },
      {
        id: "recent",
        heading: "เหตุการณ์ล่าสุด",
        body: [
          "แสดง 8 เหตุการณ์ล่าสุดจากบันทึกการใช้งาน แต่ละแถวมีประเภทเหตุการณ์ (เช่น user.signed_in = เข้าสู่ระบบ, user.created = สร้างผู้ใช้, user.banned = ระงับผู้ใช้) รหัสผู้ใช้ (User ID) ของผู้ใช้ที่เกี่ยวข้อง และวันเวลาที่เกิดขึ้น",
          'กดลิงก์ "ดูบันทึกทั้งหมด" ที่มุมขวาบนของกล่องเพื่อไปยังหน้า "บันทึกการใช้งาน" ซึ่งค้นหา กรอง ดูรายละเอียด และส่งออกได้',
        ],
        shot: {
          file: "overview-recent.png",
          caption: 'กล่อง "เหตุการณ์ล่าสุด" พร้อมลิงก์ "ดูบันทึกทั้งหมด"',
        },
        tips: [
          "ถ้าไม่เห็นกล่องนี้ แปลว่าบทบาทของคุณไม่มีสิทธิ์อ่านบันทึกการใช้งาน",
          'รหัสผู้ใช้ในแถวเป็นรหัสยาว (UUID) ไม่ใช่อีเมล เพื่อหาว่าเป็นใคร ให้คัดลอกไปค้นหาในหน้า "ผู้ใช้"',
        ],
      },
    ],
    related: ["getting-started", "users", "audit-logs", "sign-in-method"],
  },
  en: {
    id: "overview",
    title: "Overview",
    summary:
      "The console's home page: key numbers at a glance — users, sign-ins, failed sign-in attempts, MFA adoption, a 14-day sign-in chart and the latest events.",
    access:
      'Anyone who may read users (e.g. owner, admin, auditor) can open it. "Recent events" is shown only to people who may read audit logs. The page is read-only — there is nothing to change here.',
    shot: {
      file: "overview-page.png",
      caption: 'The "Overview" page: five number tiles, the 14-day sign-in chart and recent events',
    },
    sections: [
      {
        id: "open",
        heading: "Opening the overview",
        body: [
          'Click "Overview" at the top of the navigator. It is also the first page you see after signing in. The numbers are fetched from the server each time the page opens; reload the page (F5) for the latest values.',
          'While loading, grey placeholders blink in place of the numbers. If loading fails, a "Something went wrong" box with a "Retry" button appears.',
        ],
      },
      {
        id: "tiles",
        heading: "Number tiles",
        fieldsTitle: "What each tile means",
        fields: [
          {
            name: "Total users",
            description:
              "All accounts in the system, of every user type (employees, customers, partners, …) and every status, including banned and pending accounts.",
          },
          {
            name: "Active (7 days)",
            description:
              "How many different users signed in successfully at least once in the last 7 days (rolling, counted back from now).",
          },
          {
            name: "Sign-ins today",
            description:
              "Successful sign-ins today (one person signing in three times counts three). The day starts at midnight UTC — 07:00 Thailand time.",
          },
          {
            name: "Failed sign-ins (24 h)",
            description:
              "Unsuccessful sign-in attempts (e.g. wrong password) in the last 24 hours. An unusually high number may mean someone is guessing passwords.",
          },
          {
            name: "MFA adoption",
            description:
              "The percentage of all users who have two-factor authentication turned on. Higher is safer.",
          },
        ],
        tips: [
          'If "Failed sign-ins (24 h)" is unusually high, open "Audit logs" and filter for the event user.sign_in_failed to see which accounts and IP addresses are involved.',
          'If "MFA adoption" is low, consider a stricter MFA policy on "Sign-in method", or a 2FA rule per user type on "User types".',
        ],
      },
      {
        id: "chart",
        heading: 'The "Sign-ins, last 14 days" chart',
        body: [
          "A line chart of successful sign-ins per day for the last 14 days (today included). The horizontal axis shows the date as month-day (every other day is labelled); the vertical axis is the number of sign-ins.",
          'Hover a point to see the exact date and count. Days follow UTC, like the "Sign-ins today" tile.',
        ],
        tips: [
          "Use it to see trends — fewer sign-ins over holidays, more after launching a new application. A sudden drop to zero on a working day may mean a problem with the sign-in page: tell IT.",
        ],
      },
      {
        id: "recent",
        heading: "Recent events",
        body: [
          "Shows the 8 latest audit log events. Each row has the event type (e.g. user.signed_in = signed in, user.created = user created, user.banned = user banned), the User ID of the user concerned and the date and time.",
          'Click "View all audit logs" at the top right of the box to open the "Audit logs" page, where you can filter, see details and export.',
        ],
        shot: {
          file: "overview-recent.png",
          caption: 'The "Recent events" box with the "View all audit logs" link',
        },
        tips: [
          "If you do not see this box, your roles do not include reading audit logs.",
          'The ID in a row is a long User ID (UUID), not an email. To find out who it is, paste it into the search on the "Users" page.',
        ],
      },
    ],
    related: ["getting-started", "users", "audit-logs", "sign-in-method"],
  },
};

export default topic;
